exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-profile__mob-head{background-color:#464a53}.user-profile__mob-head .user-nav{width:100%;overflow-x:auto;padding:0 16px;white-space:nowrap}.user-profile__mob-bg{min-height:calc(100vh - 56px - 72px - 170px);padding-top:40px;background-color:#fff}@media(min-width: 1160px){.user-profile__mob-bg{background-color:#f3f3f3}}@media(min-width: 1160px){.user-profile__wrap{padding-top:40px}.user-profile__wrap::after{display:table;content:\"\";clear:both}}.user-profile__tabs-container{min-height:calc(100vh - 360px)}@media(min-width: 1160px){.user-profile__tabs-container{float:left;min-height:calc(100vh - 230px);-ms-flex-order:-1;order:-1;padding-top:0;padding-right:32px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??postcss!./node_modules/sass-loader/dist/cjs.js!./src/routes/main/userprofile/style.scss
// module id = 1303
// module chunks = 62